<template>
  <a-spin :spinning="isLoading">
    <div class="advertisements">
      <div class="px-5 p-4 flex justify-between items-center">
        <h2>Advertisements Table (No visible)</h2>
        <div>
          <router-link to="/advertisements/new">
            <a-button type="primary">Create Ad</a-button>
          </router-link>
        </div>
      </div>
      <a-row>
        <Table :columns="columns" :data="advertisements">
          <template v-slot:id="scope">
            <Icon name="Document" class="advertisement__icon" />
            <p>{{ scope.item.id }}</p>
          </template>
          <template v-slot:name="scope">
            <img :src="scope.item.logo" class="advertisement__logo" />
            <p>{{ scope.item.name }}</p>
          </template>
          <template v-slot:tags="scope">
            <div class="advertisement__tags">
              <a-tag color="green" v-for="tag in scope.item.tags" :key="tag">
                {{ tag }}
              </a-tag>
            </div>
          </template>
          <template v-slot:updated_at="scope">
            <p>{{ formatDate(scope.item.updated_at) }}</p>
          </template>
          <template v-slot:actions="scope">
            <router-link :to="`/advertisements/edit/${scope.item.id}`">
              <a-button>Edit</a-button>
            </router-link>
          </template>
          <template v-slot:visible="scope">
            <Switch v-model="scope.item.visible" @change="handleVisibilityChange(scope.item)" />
          </template>
          <template v-slot:popover="scope">
            <div class="popover">
              <div class="popover__header" v-if="scope.item.media_source">
                <a
                    :href="scope.item.media_source"
                    target="_blank"
                    class="popover__url"
                    :id="`url${scope.item.id}`"
                >{{ scope.item.media_source }}</a
                >
                <button
                    class="btn_copy"
                    :data-clipboard-target="`#url${scope.item.id}`"
                >
                  Copy URL
                </button>
              </div>
              <div class="popover__body">
                <template v-if="scope.item.media_source">
                  <p>Preview</p>
                  <video
                      width="240"
                      height="240"
                      controls
                      v-if="scope.item.media_source.includes('.mp4')"
                  >
                    <source :src="scope.item.media_source" type="video/mp4" />
                  </video>
                  <img
                      :src="scope.item.media_source"
                      alt=""
                      class="advertisements__item__media"
                      v-if="
                    scope.item.media_source.includes('.png') ||
                      scope.item.media_source.includes('.jpg')
                  "
                  />
                </template>
                <p>Analysis</p>
                <p style="width:240px">{{ scope.item.analysis }}</p>
              </div>
            </div>
          </template>
        </Table>
      </a-row>
    </div>
  </a-spin>

</template>

<script>
import { onMounted, onUnmounted, computed } from "vue";
import { useStore } from "vuex";
import moment from "moment";
import Clipboard from "clipboard";
import Table from "@/components/Table/index";
import Icon from "@/components/UI/Icon";
import Switch from "@/components/UI/Switch.vue";

export default {
  components: {Switch, Table, Icon },
  data() {
    return {
      isLoading: false,
      columns: [
        {
          title: "ID",
          dataIndex: "id",
          key: "id",
          style: {
            width: "350px",
            flex: "none",
          },
          class: "open_popover",
          slot: true,
        },
        {
          title: "Brand",
          dataIndex: "name",
          key: "id",
          slot: true,
          class: "open_popover",
        },
        {
          title: "Tags",
          dataIndex: "tags",
          key: "tags",
          slot: true,
          style: {
            position: "relative",
          },
        },
        {
          title: "Last Modified",
          dataIndex: "updated_at",
          key: "updated_at",
          slot: true,
        },
        {
          title: "Actions",
          dataIndex: "actions",
          key: "actions",
          slot: true,
        },
        {
          title: "Visible",
          dataIndex: "visible",
          key: "visible",
          slot: true,
        }
      ],
    };
  },
  methods: {
    formatDate(value) {
      return moment(value).fromNow();
    },
    async handleVisibilityChange(item) {
      await this.$store.dispatch("UPDATE_VISIBILITY", {
        id: item.id,
        visible: item.visible,
      });
    }
  },
  setup() {
    const store = useStore();

    onMounted(async () => {
      await store.dispatch("GET_ADVERTISEMENTS", { visible: false });
      new Clipboard(".btn_copy");
      window.addEventListener("scroll", onScroll);
    });

    onUnmounted(() => {
      store.commit("SET_PAGE", 0);
      store.commit("SET_ADVERTISEMENTS", null);
      window.removeEventListener("scroll", onScroll);
    });

    const advertisements = computed(() => store.state.advertisements);

    const onScroll = async () => {
      if (store.state.totalAdvertisements > advertisements.value.length) {
        if (
            document.documentElement.scrollHeight ===
            document.documentElement.scrollTop +
            document.documentElement.offsetHeight
        ) {
          await store.dispatch("GET_ADVERTISEMENTS", { visible: false });
        }
      }
    };

    return { advertisements, onScroll };
  },
};
</script>

<style scoped>
.advertisements {
}
.advertisements__item__media {
  max-width: 200px;
}
.popover {
  padding: 5px 10px;
}
.popover__url {
  display: block;
  width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.popover__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.popover__body {
  display: grid;
  grid-template-columns: 100px auto;
}
.advertisement__tags {
  position: absolute;
  width: 100%;
  height: 100%;
  display: grid;
  grid-auto-flow: column;
  gap: 5px;
  justify-content: start;
  align-items: center;
  overflow: hidden;
  background-color: #fff;
  padding-top: 5px;
}
.advertisement__tags:hover {
  grid-auto-flow: row;
  height: auto;
  overflow: initial;
  flex-wrap: wrap;
  z-index: 20;
  padding: 10px;
  border: 1px solid rgb(214, 214, 214);
  border-radius: 2px;
}
.advertisement__icon {
  width: 20px;
  margin-right: 7px;
}
.advertisement__logo {
  width: 30px;
  height: 30px;
  margin-right: 10px;
  object-fit: contain;
  object-position: left;
  border-radius: 100%;
}
</style>
